import { Link } from 'react-router-dom';
import { decrypt } from '../../utils/encodingdecoding';
import { gencrestMerchantId, starblazeMerchantId } from '../../utils';

export const getColumns = () => {
	const isStarblazeMerchant =
		decrypt(localStorage.getItem('merchantcode')) === starblazeMerchantId;

	return [
		{
			Header: isStarblazeMerchant ? 'Customer Name' : 'Customer Code',
			Footer: isStarblazeMerchant ? 'Customer Name' : 'Customer Code',
			// plain-text accessor so the global search can match by name/code
			accessor: 'customerLabel',
			Cell: ({ row }) => row.original.customerCode,
		},

		isStarblazeMerchant
			? {
				Header: 'Order Date',
				Footer: 'Order Date',
				accessor: 'orderDate',
			}
			: {
				Header: 'Voucher Code',
				Footer: 'Voucher Code',
				accessor: 'vouchercode',
			},
		{
			Header: isStarblazeMerchant ? 'Product Name' : 'Voucher Name',
			Footer: isStarblazeMerchant ? 'Product Name' : 'Voucher Name',
			accessor:'voucherName',
		},
		{
			Header: 'Value',
			Footer: 'Value',
			accessor: 'value',
		},

		...(isStarblazeMerchant
			? [
				{
					Header: 'Status',
					Footer: 'Status',
					accessor: 'remarks',
				},
			]
			: [
				{
					Header: 'Expiry Date',
					Footer: 'Expiry Date',
					accessor: 'expiredate',
				},
			]),

		...(decrypt(localStorage.getItem('Id')) === gencrestMerchantId
			? [
				{
					Header: 'Assign Date',
					Footer: 'Assign Date',
					accessor: 'assign',
				},
				{
					Header: 'Slogan',
					Footer: 'Slogan',
					accessor: 'remarks',
				},
			]
			: []),

		{
			Header: 'Action',
			Footer: 'Action',
			accessor: 'action',
		},
	];
};
